import req from "@/axios/index.js";

// 生成验证码
export function getDoctorCaptcha (params) {
  return req("get", "doctor/auth/captcha", params);
}

// 登录
export function getDoctorToken (params) {
  return req("post", "doctor/auth/token", params);
}
// 获取医生信息
export function getDoctorInformation (params) {
  return req("get", "doctor/information", params);
}
// 获取订单列表
export function getOrderList (params) {
  return req("get", "doctor/order/list", params);
}
// 获取订单详情
export function getOrderDetail (params) {
  return req("get", "doctor/order/details", params);
}
// 获取医生排期
export function getSchedule (params) {
  return req("get", "doctor/schedule/template", params);
}
// 查看医生排期
export function getPeriod (params) {
  return req("get", "doctor/period/list", params);
}
// 添加医生排期
export function addSchedule (params) {
  return req("post", "doctor/schedule/schedule", params);
}
// 添加医生排期(时间)
export function addPeriod (params) {
  return req("post", "doctor/schedule/addPeriod", params);
}
// 修改医生排期(时间)
export function editPeriod (params) {
  return req("post", "doctor/schedule/editPeriod", params);
}
// 删除医生排期
export function delPeriod (params) {
  return req("post", "doctor/schedule/delPeriod", null, { params });
}
// 获取退款原因
export function getRefundRemark (params) {
  return req("post", "doctor/order/refund/cause", null, { params });
}
// 获取医生常用语
export const getCommonWordsList = function (params) {
  return req("get", "doctor/phrase/list", params);
};

// 添加医生常用语
export const addCommonWords = function (data) {
  return req("post", "doctor/phrase/add", data);
};

// 删除医生常用语
export const deleteCommonWords = function (params) {
  return req("get", "doctor/phrase/remove", params);
};
// 修改常用语
export const updateCommonWords = function (params) {
  return req("post", "doctor/phrase/modify", params);
};
// 查看病历
export function caseQueryById (params) {
  return req("get", "doctor/case/details", params);
}
// 修改病历
export function updateCase (params) {
  return req("post", "doctor/case/updateCase", params);
}
// 药品列表
export function getDrugList (data) {
  return req("post", "doctor/drugs/queryPage", data);
}
// 保存处方信息
export function saveHisRecipeReq (params) {
  return req("post", "doctor/recipe/save", params);
}
// 修改处方信息
export function editHisRecipeReq (params) {
  return req("post", "doctor/recipe/edit", params);
}
// 处方列表
export function getPrescriptionList (params) {
  return req("get", "doctor/recipe/list", params);
}
// 处方列表详情
export function getPrescriptionForm (params) {
  return req("get", "common/prescription/preview", params);
}
// 药品信息-获取开处方相关字典
export function addDictMap (params) {
  return req("get", "doctor/drugs/dict", params);
}
// 获取个人处方信息
export function getRecipe (params) {
  return req("get", "doctor/recipe/chat", params);
}
// 处方列表统计接口
export function getRecipeCount (params) {
  return req("get", "doctor/recipe/statistics", params);
}

// 发送消息时调用接口
export function readImRecord (data) {
  return req("post", "doctor/im/record", data);
}

// 根据accid获取用户id
export function getPatientByAccid (params) {
  return req("get", "im/getPatientByAccid", params);
}

// *********** 旧接口 *************
// 首页医生详情
export const getDoctorInfo = function (params) {
  return req("get", "doctor/information", params);
};

// 医生修改
export const doctorEdit = function (params) {
  return req("post", "doctor/edit/info/base", params);
};

//关于我们
export const agreemenInfo = function (params) {
  return req("get", "doctor/information/aboutUs", params);
};

//断趋势图
// export const getIndexChart = function(params) {
//   return req("get", "doctor/orderTreat/myDiagnosticChart", params);
// };

// 消息接口
// export const getMessageList = function(params) {
//   return req("get", "doctor/annountCement/list", params);
// };

//医生职称（配置）
export const getSystem = function (params) {
  return req("get", `doctor/dict/dictMap`, params);
};

// 消息已读接口
export const messageUpdate = function (params) {
  return req("get", "doctor/annountCement/editReadStatus", params);
};

// 消息全部已读
export const messageAllRead = function (params) {
  return req("put", "doctor/annountCement/readAll", params);
};

//处方统计
export const prescriptionTotal = function (params) {
  return req("get", "doctor/prescription/countRp", params);
};
//处方列表
export const getPrescription = function (params) {
  return req("get", "doctor/prescription/list", params);
};

// 设置更换手机号码
export const changMobile = function (params) {
  return req("get", "doctor/edit/mobile", params);
};

//注销账户
export const delInfo = function (params) {
  return req("post", "doctor/logoff", params);
};

// 首页我的患者列表
// TODO 问诊订单旧接口
export const getSickList = function (params) {
  return req("get", "doctor/information/myMember", params);
};

// 退费列表
export const getMoneBackList = function (params) {
  return req("get", "doctor/hisMemberRefund/list", params);
};
// 退费列表详情
export const getMoneBackDetails = function (params) {
  return req("get", "member/hisMemberRefund/selectInfo", params);
};
// 撤销退费
export const undoMoneBack = function (params) {
  return req("get", "doctor/hisMemberRefund/delete", params);
};
//值班信息
export const dutyInfo = function (params) {
  return req("get", "doctor/information/myPlan", params);
};

//报告列表
export const reportList = function (params) {
  return req("get", "doctor/report/list", params);
};

//预约确认拒绝
export const appointHande = function (params) {
  return req("get", "doctor/orderBook/setStatus", params);
};

// 我的钱包统计接口
export const getWallet = function (params) {
  return req("get", "doctor/money/statistics", params);
};

// 我的钱包收入列表
export const getWalletList = function (params) {
  return req("get", "doctor/money/list", params);
};

// 获取提现日志
export const getCashout = function (params) {
  return req("get", "doctor/cashLog/list", params);
};

// 我的钱包申请提现
export const addCashout = function (params) {
  return req("post", "doctor/cashLog/add", params);
};

//处方远程搜索
export const drugSearch = function (params) {
  return req("get", "doctor/drug/list", params);
};

//获取疾病列表
export const disease_code = function (params) {
  return req("get", "doctor/disease/list", params);
};

//获取擅长疾病列表
export const disease_code_selectList = function (params) {
  return req("get", "doctor/disease/selectList", params);
};

// //患者信息
// export const patientsInfo = function (params) {
//   return req('get', 'pc/Prescription/get_sick_info', params)
// }

//患者信息
export const patientsInfo = function (params) {
  return req("get", "/doctor/orderTreat/memberInfo", params);
  // return req('get', '/doctor/information/memberInfo', params)
};

//获取修改密码状态
export const getIsUpdate = function (params) {
  return req("get", "/pharmacist/information/isUpdate", params);
};

//修改密码
export const updatePassword = function (params) {
  return req("post", "/doctor/edit/pwd", params);
};

//药方添加--处方单
export const prescriptionAdd = function (params) {
  return req("post", "doctor/prescription/add", params);
};

//诊断结束
export const ordersClose = function (params) {
  return req("get", "doctor/orderTreat/closeOrder", params);
};

//地区三级
export const getCityList = function (params) {
  return req("get", "system/area/list", params);
};

// 获取所属医院
export const getHospital = function (params) {
  return req("get", "system/hospital/list", params);
};

// 获取所属科室
export const getDepartment = function (params) {
  return req("get", "system/department/list", params);
};

// 获取协议
export const getAgreement = function (params) {
  return req("get", "doctor/agreement/list", params);
};

// 设置电子签名
export const setSign = function (params) {
  return req("get", "doctor/information/setSign", params);
};
// 申请退费
export const setMoneyback = function (params) {
  return req("post", "doctor/hisMemberRefund/add", params);
};
// 创建会诊
export const createdConsultation = function (params) {
  return req("post", "doctor/orderCons/add", params);
};
// 获取专家
export const getDoctorList = function (params) {
  return req("get", "doctor/information/expertsList", params);
};
// 邀请专家
export const getAddDoctor = function (params) {
  return req("get", "doctor/orderCons/addDoctor", params);
};
// 获取会诊列表
export const getConsultationList = function (params) {
  return req("get", "doctor/orderCons/myConsList", params);
};
//取消会诊
export const setCancelCons = function (params) {
  return req("get", "doctor/orderCons/cancelCons", params);
};
//结束会诊
export const setEndCons = function (params) {
  return req("get", "doctor/orderCons/endCons", params);
};
//进入会诊时 判断是专家还是医生
export const judgeCons = function (params) {
  return req("get", "doctor/orderCons/enterIntoCons", params);
};
//转诊管理-添加
export const setTransferAdd = function (params) {
  return req("post", "doctor/hisOrderReferral/add", params);
};
//转诊管理-列表
export const getTransferList = function (params) {
  return req("get", "doctor/hisOrderReferral/list", params);
}; //转诊管理-取消转诊
export const setCancelReferral = function (params) {
  return req("get", "doctor/hisOrderReferral/cancelReferral", params);
}; //转诊管理-通过id查询
export const getQueryById = function (params) {
  return req("get", "doctor/hisOrderReferral/queryById", params);
};
// ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓PHP↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓

//圖片收藏
export const filmAdd = function (params) {
  return req("post", "pc/readfilm/add", params);
};

//报告生成
export const setReport = function (params) {
  return req("get", "pc/doctor/report", params);
};

//报告生成  医生诊断生成报告
export const setCaseReport = function (params) {
  return req("get", "pc/Prescription/preview", params);
};
//报告生成  医生处方生成报告
export const setPrecriptionReport = function (params) {
  return req("get", "pc/Prescription/casesPreview", params);
};

//阅片列表
export const readfilmList = function (params) {
  return req("get", "pc/readfilm/index", params);
};

//诊断结果（远程搜索）
export const diagnose_result_search = function (params) {
  return req("get", "pc/diagnose_result/index", params);
};
//医嘱（远程搜索）
export const doctor_advice_search = function (params) {
  return req("get", "pc/doctor_advice/index", params);
};
export const readfilmPicList = function (params) {
  return req("get", "pc/readfilm/getReadFilm", params);
};
export const reportAdd = function (params) {
  return req("post", "pc/report/add", params);
};
export const eyeCase = function (params) {
  return req("get", "pc/eye_case/index", params);
};

//签名
export const prescription = function (params) {
  return req("get", "/doctor/prescription/sign", params);
};

//处方单信息
export const prescriptionReport = function (params) {
  return req("get", "pc/prescription/prescriptionReport", params);
};

//查看评论接口
export const getComment = function (params) {
  return req("get", "/doctor/comment/commentInfo", params);
};

//服务类型分页查询
export const getServiceList = function (params) {
  return req("get", "/doctor/service/list", params);
};

// 服务类型编辑
export const getServiceType = function (params) {
  return req("post", "/doctor/service/save", params);
};

//服务时间分页查询
export const getServiceTimeList = function (params) {
  return req("get", "/doctor/information/myPlan", params);
};

//设置服务时间
export const setServiceTime = function (params) {
  return req("post", "/doctor/information/setPlan", params);
};

// 不良反应添加
export const addAdverseEvent = function (params) {
  return req("post", "/doctor/event/add", params);
};

// 医生不良反映管理-数据展示
export const addAdverseShow = function (params) {
  return req("get", "/doctor/event/show", params);
};

// 医生不良反映管理-分页查询
export const addAdverseShowList = function (params) {
  return req("get", "/doctor/event/pageList", params);
};

// 医生不良反映管理-查看详情
export const addAdverseShowCheck = function (params) {
  return req("get", "/doctor/event/getInfo", params);
};

// 擅长疾病列表
export const getDiseaseListByDoctor = function (params) {
  return req("get", "/doctor/hisDoctorDisease/list", params);
};
// 擅长疾病删除
export const DiseaseDelete = function (params) {
  return req("delete", "/doctor/hisDoctorDisease/delete", params);
};
// 擅长疾病添加
export const DiseaseAdd = function (params) {
  return req("get", "/doctor/hisDoctorDisease/add", params);
};
// 根据im accid获取信息
export const memberInfoByAccId = function (params) {
  return req("get", "/doctor/orderTreat/queryOrderByMemberAccid", params);
};
// 获取验证码接口-保存患者处方信息_获取验证码
export const recipeSaveCode = function (params) {
  return req("post", "/doctor/recipe/save/code?mobile=" + params.mobile);
};
// 上传文件
export const batchUpload = function (params) {
  return req("post", "/upload/batchUpload", params);
};
// 查看pdf报告
export const getReport = function (params) {
  return req("get", "/doctor/order/getExamReport", params);
};
// 接诊开始
export const reception = function (data) {
  return req("post", "/doctor/order/reception", data);
};